<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="10">
        <div class="form-group">
          <label
                  for="excmuserdatastatus_title"
                  class="form-control-label">{{$t('views.excmuserdatastatus.form.title')}}:</label>
          <input
                  id="excmuserdatastatus_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="2">
        <div class="form-group">
          <label
                  for="excmuserdatastatus_color"
                  class="form-control-label">{{$t('views.excmuserdatastatus.form.color')}}:</label><br>
          <!--<input-->
          <!--id="excmuserdatastatus_color"-->
          <!--v-model="item.color"-->
          <!--:class="['form-control', isInvalid('color') ? 'is-invalid' : '']"-->
          <!--type="text"-->
          <!--required="true"-->
          <!--placeholder=""-->
          <!--@input="handleUpdateField('color', $event.target.value)">-->
          <el-color-picker v-model="item.color"></el-color-picker>
          <div
                  v-if="isInvalid('color')"
                  class="invalid-feedback">{{ violations.color }}</div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group">
          <label
                  for="excmuserdatastatus_description"
                  class="form-control-label">{{$t('views.excmuserdatastatus.form.description')}}:</label>
          <textarea
                  id="excmuserdatastatus_description"
                  v-model="item.description"
                  :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('description', $event.target.value)"></textarea>
          <div
                  v-if="isInvalid('description')"
                  class="invalid-feedback">{{ violations.description }}</div>
        </div>
      </b-col>
    </b-row>

    <button
            type="submit"
            class="btn btn-primary">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
